import React, { useState } from "react";
import { Formik, Field, Form } from "formik";
import { fetchAPI } from "@/utility/NetworkUtils";
import {
  Button,
  Stack,
  TextField as MuiTextField
} from "@mui/material"
import { Autocomplete, TextField } from 'formik-mui';

const ReceivingItemReceiveForm = ({
  item,
  receivingItem = null,
  onCancel = () => {},
  onSubmit = () => {},
}) => {
    

  const submitForm = ( values, { setSubmitting }) => {
    fetchAPI(`/webapi/receiving_items/${receivingItem.id}/receive`, (json)=> {
      setSubmitting(false)
      if (!json.errors) {
        onSubmit(
          json.receiving_item
        )
      } else {
        console.log({
          errors: json.errors
        })
      }
    }, {
      method: "POST",
      body: values
    })
  }

  const renderForm = (formikProps) => {
    return (
      <Form>
        <Stack spacing={2}>
          <label>
            Quantity Received:
          </label>
          <Field
            name="item_inventory_log[count]"
            type="number"
            component={TextField}
            fullWidth
          />
          {renderTrackingNumbers(formikProps)}
          <br/>
          <br/>
        </Stack>
        {renderButtons(formikProps)}
      </Form>
    )
  }

  const renderTrackingNumbers = (formikProps) => {
    if((receivingItem.receiving_item_tracking_numbers||[]).length > 0) {
      return (
        <>
          <label>
            Tracking Number:
          </label>
          <Field
            component={Autocomplete}
            name="item_inventory_log[receiving_item_tracking_number_id]"
            getOptionValue={(option) => option.id}
            options={receivingItem.receiving_item_tracking_numbers.map(x=> x.id)}
            getOptionLabel={(option) => {
              return (receivingItem.receiving_item_tracking_numbers.find(x=> x.id == option)||{}).tracking_number||""
            }}
            renderInput={(params) => < MuiTextField
              {...params}
              variant="outlined"
            />}
            fullWidth
            clearable
          />
        </>
      )
    }
  }

  const renderButtons = (formikProps) => {
    return (
      <div className="text-right sg-receiving-list-form-buttons">
        <button
          type="button"
          variant="outlined"
          onClick={onCancel}

        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={formikProps.isSubmitting}
        >
          Save
        </button>
      </div>
    )
  }
  return (
    <Formik
      initialValues={{
        item_inventory_log: {
          item_id: receivingItem.item_id,
          count: 0,
          receiving_list_item_id: receivingItem.id,
          receiving_item_tracking_number_id: null
        }
      }}
      onSubmit={submitForm}
      
    >
      {(formikProps) => renderForm(formikProps)}
    </Formik>
  )
}

export default ReceivingItemReceiveForm